import type { TranslationResource } from './en';

export const pl: TranslationResource = {
  title: 'AutoCut - Instalator',
  downloading: 'Pobieranie AutoCut',
  downloadedTitle: 'AutoCut został pomyślnie pobrany !',
  closingCountdown: 'Zamykanie za {{count}} sekund',
  alreadyInstalledTitle: 'AutoCut jest już zainstalowany',
  alreadyInstalledHelp:
    'AutoCut działa teraz jako aplikacja komputerowa. To rozszerzenie możesz odinstalować w aplikacji Creative Cloud.',
};
